<script>

  import Vue from 'vue'
  import Router from 'vue-router'
  import store from '../store/index.js'
  import Top from '../views/top';
  import Login from '../views/login'
  import Noaccess from '../../src/components/no-access'
  import Settings from '../views/settings/setting_index'
  // =======member========
  import MemberNew from '../views/settings/members/member_new'
  import Memberlist from '../views/settings/members/member_list'
  import MemberEdit from '../views/settings/members/member_edit'
  import MemberMypage from '../views/settings/members/member_mypage'
  // =======urgency========
  import SettingUrgency from '../views/settings/urgency/urgency_list'
  import SettingUrgencyNew from '../views/settings/urgency/urgency_new'
  import SettingUrgencyEdit from '../views/settings/urgency/urgency_edit'
  // =======mode========
  import SettingMode from '../views/settings/mode/mode'
  // =======location========
  import SettingLocation from '../views/settings/location/initLocation'
  // =======device========
  import SettingDevice from '../views/settings/device/device_list'
  import SettingDeviceNew from '../views/settings/device/device_new'
  import SettingDeviceEdit from '../views/settings/device/device_edit'
  // =======device========
  import TaskNew from '../views/tasks/task_new'
  import TaskEdit from '../views/tasks/task_edit'
  import TaskList from '../views/tasks/task_list'
  import TaskReport from '../views/tasks/task_report'
  // =======未確認投稿========
  import OfficialTaskList from '../views/official/official_task_list'
  import Error500 from '../views/error/500'
  // =======使用モジュール定義===
  import SettingModules from '../views/settings/module/index'

  Vue.use(Router)

  const router = new Router({
    // mode: 'history',
    routes: [
      { path: '/login',         component: Login                                          },
      { path: '/noaccess',      component: Noaccess                                       },
      { path: '/',              component: Top,               meta: {requiresAuth: true } },
      { path: '/500',           component: Error500                                       },
      { path: '/settings',      component: Settings,          meta: { requiresAuth: true}, 
        children:
        [
          { path: '/settings/members/new',                            component: MemberNew,           meta: { requiresAdmin: true, }                          },
          { path: '/settings/members/:memberId',  name: 'editMember', component: MemberEdit,          meta: { requiresAdmin: true, }                          },
          { path: '/settings/members',                                component: Memberlist,          meta: { requiresAdmin: true, }                          },
          { path: '/settings/mypage/:memberId',   name: 'mypage',     component: MemberMypage                                                                 },
          { path: '/settings/urgency',                                component: SettingUrgency,                                                              },
          { path: '/settings/urgency/new',                            component: SettingUrgencyNew,   meta: { requiresAdmin: true, }                          },
          { path: '/settings/urgency/:urgencyId', name: 'editUrgency',component: SettingUrgencyEdit,  meta: { requiresAdmin: true, }                          },
          { path: '/settings/mode',                                   component: SettingMode,         meta: { requiresAdmin: true, }                          },
          { path: '/settings/location',                               component: SettingLocation,                                                             },
          { path: '/settings/device',                                 component: SettingDevice,       meta: { requiresAdmin: true, }                          },
          { path: '/settings/device/new',                             component: SettingDeviceNew,    meta: { requiresSuper_user: true }                      },
          { path: '/settings/device/:deviceId',   name: 'editDevice', component: SettingDeviceEdit,   meta: { requiresAdmin: true, }                          },
          { path: '/settings/modules',            name: 'modules',    component: SettingModules,      meta: { requiresSuper_user: true }                      },
        ]
      },
      { path: '/task/new',        name: 'new',                component: TaskNew,             meta: { requiresAuth: true } },
      { path: '/task/list',       name: 'list',               component: TaskList,            meta: { requiresAuth: true } },
      { path: '/task/edit/:q',    name: 'edit',               component: TaskEdit,            meta: { requiresAuth: true } },
      { path: '/task/report/:q',  name: 'report',             component: TaskReport,          meta: { requiresAuth: true } },
      { path: '/official/list',   name: 'officialtasklist',   component: OfficialTaskList,    meta: { requiresAuth: true } }
    ]
  });

  router.beforeEach(function(to, from, next) {
    // 次の行き先のルートオブジェクトにメタフィールドがあるかどうかチェックする
    if(to.matched.some( record => record.meta.requiresAuth)) {
      //ユーザー情報があるかどうか
      if(store.getters['auth/check']){
        //管理者としてアクセスする場合
        if(to.matched.some( record => record.meta.requiresSuper_user)) {
          //super_user権限があるかどうか
          if(!store.getters['auth/super_user']) {
            router.replace('/')
            next({ path: '/noaccess' })
          }
          next()
        }else if(to.matched.some( record => record.meta.requiresAdmin)){
          //admin_user権限があるかどうか
          if(!store.getters['auth/admin_user']) {
            router.replace('/')
            next({ path: '/noaccess' })
          }
          next()
        }
        next()
      }else {
        next({ path: '/login', query: { redirect: to.fullPath } })
      }
    }else{
      next()
    }
  })

  export default router

</script>